import { render, staticRenderFns } from "./ServicesReservationCalendarStatistics.vue?vue&type=template&id=28944af2&"
import script from "./ServicesReservationCalendarStatistics.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationCalendarStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports